import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  createBusinessBankAccount,
  updateBusinessBankAccount,
} from '../../api/bankAccounts';
import { getBankAccountById } from '../../api/bankAccounts';
import {
  expressCreateBankAccount,
  expressGetBankAccount,
  expressUpdateBankAccount,
} from '../../api/express/bankAccounts';
import CustomButton from '../../designSystem/Button';
import CenteredCircularProgress from '../../designSystem/CircularProgress';
import Uploader from '../../designSystem/Uploader';
import { showAlert } from '../../functions/utils';
import BusinessSearcherAutocomplete from '../BusinessSearcherAutocomplete';

export const bankCodes = [
  { id: 0, name: 'Pago al Contado' },
  { id: 1, name: 'BANCO DE CHILE' },
  { id: 9, name: 'BANCO INTERNACIONAL' },
  { id: 12, name: 'BANCO DEL ESTADO DE CHILE' },
  { id: 14, name: 'SCOTIABANK SUD AMERICANO' },
  { id: 16, name: 'BANCO CREDITO E INVERSIONES' },
  { id: 17, name: 'BANCO DO BRASIL S.A' },
  { id: 18, name: 'BANCO CENTRAL DE CHILE' },
  { id: 27, name: 'CORPBANCA' },
  { id: 28, name: 'BANCO BICE' },
  { id: 29, name: 'BANCO DE A. EDWARDS' },
  { id: 31, name: 'HSBC BANK (CHILE)' },
  { id: 33, name: 'CITIBANK N.A.' },
  { id: 35, name: 'BANCO DE SANTIAGO' },
  { id: 37, name: 'BANCO SANTANDER CHILE' },
  { id: 38, name: 'BANCO EXTERIOR' },
  { id: 39, name: 'BANCO ITAU' },
  { id: 41, name: 'JP MORGAN CHASE BANK, N.A.' },
  { id: 43, name: 'BANCO DE LA NACION ARGENTINA' },
  { id: 45, name: 'THE BANK OF TOKYO MITSUBISHI UFJ,LTD.' },
  { id: 46, name: 'ABN AMRO BANK (CHILE)' },
  { id: 49, name: 'BANCO SECURITY' },
  { id: 51, name: 'BANCO FALABELLA' },
  { id: 52, name: 'DEUTSCHE BANK (CHILE)' },
  { id: 53, name: 'BANCO RIPLEY' },
  { id: 54, name: 'RABOBANK' },
  { id: 55, name: 'BANCO CONSORCIO' },
  { id: 56, name: 'BANCO PENTA' },
  { id: 57, name: 'BANCO PARIS' },
  { id: 504, name: 'BANCO BILBAO VIZCAYA ARGENTARIA, CHILE' },
  { id: 507, name: 'BANCO DEL DESARROLLO' },
  { id: 697, name: 'LA POLAR' },
  { id: 729, name: 'Prepago LOS HEROES' },
  { id: 734, name: 'FINANCIERA CONOSUR' },
  { id: 672, name: 'COOPEUCH' },
  { id: 729, name: 'PREPAGO LOS HÉROES' },
  { id: 730, name: 'TENPO' },
  { id: 732, name: 'PREPAGO LOS ANDES' },
  { id: 738, name: 'GLOBAL 66' },
  { id: 875, name: 'MERCADO PAGO' },
];

const accountTypes = [
  { id: 'Cuenta corriente', name: 'Cuenta corriente' },
  { id: 'Cuenta vista', name: 'Cuenta vista' },
  { id: 'Cuenta de ahorro', name: 'Cuenta de ahorro' },
];

interface BankAccountDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  businessId?: string;
  handleSuccessExit?: () => void;
  bankAccountId?: number;
  clientId?: string;
}

const BankAccountDialog = (props: BankAccountDialogProps) => {
  const {
    open,
    setOpen,
    businessId,
    handleSuccessExit,
    bankAccountId,
    clientId,
  } = props;
  const [businessIsHolder, setBusinessIsHolder] = useState(true);
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState<any>(null);
  const [searched, setSearched] = useState(false);
  const dispatch = useDispatch();
  const [selectedBankAccount, setSelectedBankAccount] = useState<any>({});
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [file, setFile] = useState<any>(null);
  const [editFile, setEditFile] = useState<any>(null);

  const handleFileChange = (event: any) => {
    const uploadedFile = event.target.files[0];
    setUploadedFileName(uploadedFile.name);
    setFile(uploadedFile);
    console.log(uploadedFile);
  };

  const handleGetBankAccount = async () => {
    if (!bankAccountId) {
      alert('No se ha seleccionado una cuenta bancaria');
      return;
    }
    if (clientId) {
      return expressGetBankAccount(dispatch, clientId, bankAccountId);
    }
    if (!businessId) {
      alert('No se ha seleccionado una empresa');
      return;
    }
    return getBankAccountById(dispatch, businessId, bankAccountId);
  };

  const handleUpdateBankAccount = async (formData: any) => {
    if (!bankAccountId) {
      alert('No se ha seleccionado una cuenta bancaria');
      return;
    }
    if (clientId) {
      return expressUpdateBankAccount(
        dispatch,
        clientId,
        bankAccountId,
        formData,
      );
    }
    if (!businessId) {
      alert('No se ha seleccionado una empresa');
      return;
    }

    return updateBusinessBankAccount(
      dispatch,
      businessId,
      bankAccountId,
      formData,
    );
  };

  const handleCreateBankAccount = async (payload: any) => {
    if (clientId) {
      return expressCreateBankAccount(dispatch, clientId, payload);
    }
    console.log(businessId, business);
    if (!businessId && !business) {
      alert('No se ha seleccionado una empresa');
      return;
    }
    return createBusinessBankAccount(
      dispatch,
      businessId || business.identifier,
      payload,
    );
  };

  const handleAccountNumber = (e: any) => {
    if (isNaN(e.target.value)) return;
    setSelectedBankAccount({
      ...selectedBankAccount,
      accountNumber: e.target.value,
    });
  };

  const validateAttributes = () => {
    if (
      selectedBankAccount.bankId === '' ||
      selectedBankAccount.accountType === '' ||
      selectedBankAccount.accountNumber === '' ||
      selectedBankAccount.currency === ''
    ) {
      alert('Debes completar todos los campos');
      return false;
    }
    if (!businessIsHolder) {
      let fileIsMissing = false;
      if (selectedBankAccount.fileUrl && editFile && !file) {
        fileIsMissing = true;
      }
      if (!selectedBankAccount.id && !file) {
        fileIsMissing = true;
      }
      if (selectedBankAccount.id && !selectedBankAccount.fileUrl && !file) {
        fileIsMissing = true;
      }
      if (
        selectedBankAccount.holderName === '' ||
        selectedBankAccount.holderIdentifier === '' ||
        selectedBankAccount.powerDueDate === '' ||
        fileIsMissing
      ) {
        alert(
          'Debes rellenar todos los campos extras ya que la empresa no es la dueña de la cuenta',
        );
        return false;
      }
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateAttributes()) {
      return;
    }
    setLoading(true);
    try {
      const businessIdentifier = businessId
        ? String(businessId)
        : business.identifier;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('businessIdentifier', businessIdentifier);
      formData.append('requestType', 'bankAccount');
      formData.append('requestId', businessIdentifier);
      formData.append('powerDueDate', selectedBankAccount.powerDueDate);
      formData.append('holderName', selectedBankAccount.holderName);
      formData.append('holderIdentifier', selectedBankAccount.holderIdentifier);
      formData.append(
        'bankName',
        String(
          bankCodes.find((x: any) => x.id === selectedBankAccount.bankId)?.name,
        ),
      );
      formData.append('bankId', String(selectedBankAccount.bankId));
      formData.append('type', selectedBankAccount.accountType);
      formData.append('accountNumber', selectedBankAccount.accountNumber);
      formData.append('currency', selectedBankAccount.currency);
      if (selectedBankAccount.email) {
        formData.append('email', selectedBankAccount.email);
      }
      formData.append('businessIsHolder', String(businessIsHolder));

      console.log(formData);
      const response = selectedBankAccount.id
        ? await handleUpdateBankAccount(formData)
        : await handleCreateBankAccount(formData);
      if (response) {
        showAlert(
          dispatch,
          'success',
          'Cuenta bancaria guardada correctamente',
        );
        handleSuccessExit && (await handleSuccessExit());
        setOpen(false);
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al guardar la cuenta bancaria');
    }
    setLoading(false);
  };

  const fetchBankAccount = async () => {
    try {
      setLoading(true);
      if (businessId && bankAccountId) {
        const response = await handleGetBankAccount();
        setSelectedBankAccount(response);
        const responseFormatted = {
          ...response,
          powerDueDate: response.powerDueDate?.split('T')[0],
          accountType: response.type,
        };
        setSelectedBankAccount(responseFormatted);
        setBusinessIsHolder(response.businessIsHolder);
      }
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener la cuenta bancaria');
    } finally {
      setLoading(false);
    }
  };

  const downloadPower = () => {
    window.open(selectedBankAccount.fileUrl, '_blank');
  };

  useEffect(() => {
    if (businessId) setSearched(true);
    fetchBankAccount();
  }, [businessId]);

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        {selectedBankAccount.id ? 'Editar' : 'Crear'} cuenta bancaria
      </DialogTitle>
      <DialogContent>
        {!businessId && (
          <div>
            <BusinessSearcherAutocomplete
              setBusiness={setBusiness}
              setSearched={setSearched}
            />
            <Divider />
          </div>
        )}
        {(businessId || business) && searched && (
          <div>
            <FormControl margin="dense" fullWidth>
              <InputLabel id="filter-label">Banco</InputLabel>
              <Select
                labelId="filter-label"
                id="Filtrar por estado"
                fullWidth
                value={selectedBankAccount.bankId}
                onChange={(e) =>
                  setSelectedBankAccount({
                    ...selectedBankAccount,
                    bankId: e.target.value,
                  })
                }
                label="Banco"
              >
                {bankCodes.map((x: any, index: any) => (
                  <MenuItem key={index} value={x.id}>
                    {x.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl margin="dense" fullWidth>
              <InputLabel id="filter-label">Tipo</InputLabel>
              <Select
                labelId="filter-label"
                id="Filtrar por estado"
                fullWidth
                value={selectedBankAccount.accountType}
                onChange={(e) =>
                  setSelectedBankAccount({
                    ...selectedBankAccount,
                    accountType: e.target.value,
                  })
                }
                label="Tipo"
              >
                {accountTypes.map((x: any, index: any) => (
                  <MenuItem key={index} value={x.id}>
                    {x.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Número de cuenta"
              value={selectedBankAccount.accountNumber}
              fullWidth
              margin="dense"
              onChange={(e) => handleAccountNumber(e)}
            />
            <TextField
              label="Email (Opcional)"
              value={selectedBankAccount.email}
              fullWidth
              margin="dense"
              onChange={(e) =>
                setSelectedBankAccount({
                  ...selectedBankAccount,
                  email: e.target.value,
                })
              }
            />
            <FormControl margin="dense" fullWidth>
              <InputLabel id="filter-label">Moneda</InputLabel>
              <Select
                labelId="filter-label"
                id="Filtrar por estado"
                fullWidth
                value={selectedBankAccount.currency}
                onChange={(e) =>
                  setSelectedBankAccount({
                    ...selectedBankAccount,
                    currency: e.target.value,
                  })
                }
                label="Moneda"
              >
                {['CLP', 'USD'].map((x: any, index: any) => (
                  <MenuItem key={index} value={x}>
                    {x}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div>
              {/* Add a checbox to see if we have to open a form for holder name and holder identifier */}
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={businessIsHolder}
                      onChange={(e) => setBusinessIsHolder(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="¿La empresa es titular de la cuenta?"
                />
                {!businessIsHolder && (
                  <div>
                    <TextField
                      label="Nombre del titular"
                      value={selectedBankAccount.holderName}
                      fullWidth
                      margin="dense"
                      onChange={(e) =>
                        setSelectedBankAccount({
                          ...selectedBankAccount,
                          holderName: e.target.value,
                        })
                      }
                    />
                    <TextField
                      label="RUT del titular"
                      value={selectedBankAccount.holderIdentifier}
                      fullWidth
                      margin="dense"
                      onChange={(e) =>
                        setSelectedBankAccount({
                          ...selectedBankAccount,
                          holderIdentifier: e.target.value,
                        })
                      }
                    />
                    <TextField
                      label="Fecha de vencimiento del poder"
                      value={selectedBankAccount.powerDueDate}
                      fullWidth
                      margin="dense"
                      type="date"
                      onChange={(e) =>
                        setSelectedBankAccount({
                          ...selectedBankAccount,
                          powerDueDate: e.target.value,
                        })
                      }
                    />
                    {(!selectedBankAccount.id ||
                      !selectedBankAccount.fileUrl) && (
                      <Uploader
                        buttonText="Subir documento"
                        handleFileChange={handleFileChange}
                        uploadedFileName={uploadedFileName}
                        setUploadedFileName={setUploadedFileName}
                      />
                    )}
                    {selectedBankAccount.fileUrl && editFile && (
                      <div>
                        <Uploader
                          buttonText="Actualizar documento"
                          handleFileChange={handleFileChange}
                          uploadedFileName={uploadedFileName}
                          setUploadedFileName={setUploadedFileName}
                        />
                        <Typography
                          style={{
                            cursor: 'pointer',
                            color: 'blue',
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                          onClick={() => {
                            setEditFile(false);
                          }}
                        >
                          Cancelar
                        </Typography>
                      </div>
                    )}
                    {selectedBankAccount.fileUrl && !editFile && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: 10,
                        }}
                      >
                        <Typography
                          style={{
                            cursor: 'pointer',
                            color: 'blue',
                            fontWeight: 'bold',
                          }}
                          onClick={() => {
                            setEditFile(true);
                          }}
                        >
                          Actualizar poder
                        </Typography>
                        <Typography
                          style={{
                            cursor: 'pointer',
                            color: 'blue',
                            fontWeight: 'bold',
                          }}
                          onClick={() => {
                            downloadPower();
                          }}
                        >
                          Descargar poder
                        </Typography>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          color="secondary"
          onClick={() => {
            setOpen(false);
          }}
        >
          Salir
        </CustomButton>
        <CustomButton color="primary" onClick={handleSave}>
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default BankAccountDialog;
